module.exports = __webpack_public_path__ + "static/media/DaxlinePro-Light.2bc7af9f.ttf";